import * as MuiIcons from "@mui/icons-material";

export const getMuiIcon = (iconName) => {
  return MuiIcons[iconName] || null;
};
